import { EInputValidationResultType } from "../../factorys/inputvalidation/enums/InputValidationEnums";
import { IInputValidatorItem } from "../../factorys/inputvalidation/interfaces/InputValidationInterfaces";
import { ELng } from "../../../../language/main/LanguageKeysEnums";

/**
 * @abstract This is a store for frontend-validation functions.
 * Items can be get by label-string-keys of properties
 * Items can be automatically assigend in the main->gui->factory->AppGUIElementsfactory
 */
export default class InputValidationStore {

  private static _items: IInputValidatorItem[] = [];
  public static setItem(it: IInputValidatorItem) { 
    //set default props
    if(it.type == undefined) it.type = EInputValidationResultType.Error;
    this._items.push(it); 
  }
  /**
   * @param key currently this is the label of an item
   * @param required true: throws error-message -> prevents form to be send, false: throws hint-message -> doe not affect form to be send
   * @returns IInputValidatorItem
   */
  public static getItemsByKey(key: string, required?: boolean): IInputValidatorItem[] {
    //return this._items.filter((it) => it.key == key && (required ? it.type == EInputValidationResultType.Error : it.type == EInputValidationResultType.Hint));
    return this._items.filter((it) => it.key == key);
  }

  public static getCommonRequriedItem(minChars: number): IInputValidatorItem[] {
    try {
      const result = this.getItemsByKey("common_required_" + minChars.toString())
      if (result.length == 0) throw Error();
      return result;
    } catch (e) {
      return this.getItemsByKey("common_required_1" + minChars.toString())
    }
  }

  //#region init
  constructor() {
    new Factory();
  }
  //#endregion
}

class Factory {

  private tag = "InputValidationStore";

  constructor() {
    this.setItems();
  }
 
  private setItems() {

    //#region ELngUnassigned
    InputValidationStore.setItem({ key: ELng.prop_email.valueOf(), f: (it: string) => { return (new RegExp(/^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/).test(it)) }, msgOnError: (ELng.iv_invalid_email.valueOf()), type: EInputValidationResultType.Error })
    InputValidationStore.setItem({ key: ELng.prop_email.valueOf(), f: (it: string) => { return (new RegExp(/^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/).test(it)) }, msgOnError: (ELng.iv_invalid_email.valueOf()), type: EInputValidationResultType.Hint })
    //#endregion


    //#region ELngCommon
    InputValidationStore.setItem({ key: "common_required_1", f: (it: string) => { if (it == null || it == undefined || it.length < 1) return false; return true; }, msgOnError: (ELng.iv_invalid_common_isrequired_1.valueOf()), type: EInputValidationResultType.Error })
    InputValidationStore.setItem({ key: "common_required_2", f: (it: string) => { if (it == null || it == undefined || it.length < 2) return false; return true; }, msgOnError: (ELng.iv_invalid_common_isrequired_2.valueOf()), type: EInputValidationResultType.Error })
    InputValidationStore.setItem({ key: "common_required_3", f: (it: string) => { if (it == null || it == undefined || it.length < 3) return false; return true; }, msgOnError: (ELng.iv_invalid_common_isrequired_3.valueOf()), type: EInputValidationResultType.Error })
    InputValidationStore.setItem({ key: "common_required_4", f: (it: string) => { if (it == null || it == undefined || it.length < 4) return false; return true; }, msgOnError: (ELng.iv_invalid_common_isrequired_4.valueOf()), type: EInputValidationResultType.Error })
    InputValidationStore.setItem({ key: "common_required_8", f: (it: string) => { if (it == null || it == undefined || it.length < 8) return false; return true; }, msgOnError: (ELng.iv_invalid_common_isrequired_8.valueOf()), type: EInputValidationResultType.Error })
    //#endregion
  }


    //#region functions
    // private timeStampValidation(it: string): boolean {
    //   const regExResult = (new RegExp(/^(\d{4})-(\d{2})-(\d{2})/).test(it)); 
    //   if (!regExResult) return false; 
    //   try { const year = parseInt(it.split("-")[0]); if (year < 1970) return false; return true; 
    //   } catch (e) { return true; } 
    // }
  
    // private isNotNullOrEmpty(it: string): boolean {
    //   if (it == null || it == undefined || it == "" || it.includes("_null")) return false; 
    //   return true; 
    // }
  
    // private isNumberInt(it: string): boolean {
    //   try {
    //     const r = parseInt(it);
    //     if (!isNaN(r)) {
    //       console.log(this.tag + "isNumberInt: true"); 
    //       return true
    //     }
    //     console.log(this.tag + "isNumberIntfalse"); 
    //     return false;
    //   } catch (e) {
    //     console.log(this.tag + "isNumberIntfalse"); 
    //     return false
    //   }
    // }
    //#endregion
}